import { z } from "zod";
import { baseSearchSchema } from "../-search-params";

export const cameraSearchSchema = z.object({
	...baseSearchSchema.shape,
});

export type CameraSearch = z.infer<typeof cameraSearchSchema>;

export const validateCameraSearch = (search: Record<string, unknown>): CameraSearch => {
	return cameraSearchSchema.parse(search);
};
